<script>
import WellCome from '@/views/account/main/components/WellCome.vue'
import CheckNewReport from '@/views/account/main/components/CheckNewReport.vue'
import VideoBanner from '@/views/account/main/components/VideoBanner.vue'
import StatData from '@/views/account/main/components/StatData.vue'
import StatCount from '@/views/account/main/components/StatCount.vue'
import CatchPermissions from '@/views/account/main/components/CatchPermissions.vue'
// import CatchYear from '@/views/account/main/components/CatchYear.vue'
import CatchByFish from '@/views/account/main/components/CatchByFish.vue'
import ActionsJournal from '@/views/account/main/components/ActionsJournal.vue'
import RegionMonitoring from '@/views/account/main/components/RegionMonitoring.vue'

export default {
	name: 'MainPage',
	components: {
		WellCome,
		CheckNewReport,
		VideoBanner,
		StatData,
		StatCount,
		CatchPermissions,
		// CatchYear,
		CatchByFish,
		ActionsJournal,
		RegionMonitoring,
	},
	data() {
		return {
			activeTab: 'regions',
		}
	},
	computed: {
		userId() {
			return this.$store?.state?.userObject?.role_id
		},
		getUserTag() {
			if ([3].includes(this.userId)) return `subject`
			return `tir-go`
		},
		isShortView() {
			return ![3].includes(this.userId)
		},
		isSalesman() {
			return this.$store.state.userObject?.role?.name === 'salesman'
		},
		isGo() {
			const roleName = this.$store?.state?.userObject?.role?.name
			return ['go', 'go_manager', 'go_check'].includes(roleName)
		},
	},
	methods: {
		handleFishingYearChanged() {},
	},
}
</script>

<template>
	<div class="wrap__content">
		<div v-if="userId" class="container">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['Account']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<WellCome
						class="mb-[10px]"
						:isSalesman="isSalesman"
						@fishing-year-changed="handleFishingYearChanged"
					/>
					<CheckNewReport class="mb-[10px]" />

					<template v-if="isGo">
						<div
							class="bg-white/90 px-[30px] py-[16px] shadow-main rounded-t-[10px] backdrop-blur-[10px] flex items-center flex-wrap gap-[16px] justify-between"
						>
							<div class="font-main font-semibold text-[18px] text-third uppercase">
								{{ $t('titles.region_monitoring') }}
							</div>
							<div class="inline-flex gap-[4px] bg-[#F1F3F9] p-[3px] rounded-[10px]">
								<button
									class="tab-btn"
									:class="{ active: activeTab === 'regions' }"
									@click="activeTab = 'regions'"
								>
									{{ $t('titles.tab_by_region') }}
								</button>
								<button
									class="tab-btn"
									:class="{ active: activeTab === 'species' }"
									@click="activeTab = 'species'"
								>
									{{ $t('titles.tab_by_species') }}
								</button>
								<button
									class="tab-btn"
									:class="{ active: activeTab === 'permits' }"
									@click="activeTab = 'permits'"
								>
									{{ $t('titles.tab_by_permits') }}
								</button>
							</div>
						</div>

						<div v-show="activeTab === 'regions'">
							<!-- <VideoBanner class="mb-[30px]" /> -->
							<StatData :user-tag="getUserTag" class="mb-[30px]" />
							<RegionMonitoring class="mb-[30px]" />
							<ActionsJournal />
						</div>

						<div v-show="activeTab === 'species'">
							<CatchByFish :isSalesman="isSalesman" :user-tag="getUserTag" />
						</div>

						<div v-show="activeTab === 'permits'">
							<CatchPermissions :isSalesman="isSalesman" :user-tag="getUserTag" />
						</div>
					</template>

					<template v-else>
						<!-- <VideoBanner v-if="!isSalesman" class="mb-[30px]" /> -->
						<StatData :user-tag="getUserTag" :isGo="isGo" class="mb-[10px]" />
						<StatCount v-if="!isShortView" :user-tag="getUserTag" class="mb-[30px]" />
						<div class="grid grid-cols-1 gap-[30px] mb-[30px]">
							<CatchPermissions :isSalesman="isSalesman" :user-tag="getUserTag" />
							<!-- <CatchYear /> -->
						</div>
						<div class="grid grid-cols-1 md:grid-cols-2 gap-[30px] mb-[30px]">
							<CatchByFish :isSalesman="isSalesman" :user-tag="getUserTag" />
							<ActionsJournal />
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.tab-btn {
	background: transparent;
	border: none;
	font-family: inherit;
	font-size: 11px;
	font-weight: 600;
	color: #6b7788;
	padding: 6px 12px;
	border-radius: 7px;
	cursor: pointer;
	transition: color 0.2s ease, background-color 0.2s ease;
}

.tab-btn:hover {
	color: #151d48;
}

.tab-btn.active {
	background: #fff;
	color: #157fee;
	box-shadow: 0 1px 2px rgba(20, 30, 60, 0.08);
}
</style>
